export const defaultElementData = {
    nodeInfo: { // 节点信息
        desc: '',
        execLog: 0, // 查看流程图
        dueDate: '', // 任务到期时间
        expireDate: '', // 任务到期提醒时间
        difficultScore: 1, // 任务难度分
        difficultLevel: 1, // 任务难度级别
        viewOrder: 0, // 列表显示顺序
        isApproval: 0, // 是否为审批流节点
        isSubProcess: 0, // 是否为子流程节点
        supTaskformCtr: 0, // 是否上级表单选项控制当前表单显示
        synTaskAssigneeFlag: 0,
        taskRemarkFlag: 0,
        updCountersigTaskFlag: 0,
        synTaskBtnFlag: 0,
        formApprovalFlag: 0,
        autoCompleteFlag: 0,
        onlyLastFormData: 0,
        updHisProcessDataFlag: 0,
        canbyMobile: 0,
        unSynAppForm: 0,
        unSynAppFormByReject: 0,
        deleteFileAuth: 0
    },
    executor: { // 执行人
        execType: 0, // 节点任务执行方式
        modeType: 0, // 执行人选取方式
        executors: [] // 执行人
    },
    dataOperate: { // 数据操作
        operateType: 0, // 操作方式
        dataSource: '', // 目标数据来源
        formId: '' // 已经选择的自定义表单
    }
};



// WEBPACK FOOTER //
// ./src/pages/process/ProcessEditor/defaultData.js